import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['timer', 'progress']

  static values = {
    timeExpiresAt: String,
    createdAt: String
  }

  connect () {
    this.startDate = Date.parse(this.createdAtValue)
    this.endDate = Date.parse(this.timeExpiresAtValue)
    this.element.dataset.expired = 'false'
    this.updateView()
    this.timer = setInterval(() => this.updateView(), 1000)
  }

  disconnect () {
    clearInterval(this.timer)
  }

  updateView () {
    const currentDate = new Date().getTime()
    this.updateTimer(currentDate)
    this.updateProgress(currentDate)
  }

  updateTimer (currentDate) {
    const distance = this.endDate - currentDate

    if (distance < 0) {
      this.timerTarget.textContent = '00:00'
      this.element.dataset.expired = 'true'
      return
    }

    const minutes = String(Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, '0')
    const seconds = String(Math.floor((distance % (1000 * 60)) / 1000)).padStart(2, '0')
    this.timerTarget.textContent = `${minutes}:${seconds}`
  }

  updateProgress (currentDate) {
    const distanceLeft = this.endDate - currentDate

    if (distanceLeft < 0) {
      this.progressTarget.style.width = '0%'
      clearInterval(this.timer)
      return
    }

    const total = this.endDate - this.startDate
    const percentage = (distanceLeft / total) * 100
    this.progressTarget.style.width = `${percentage}%`
  }
}
